import { GzPolicyUiSettingsGridItemFormWebComponent } from './component/GzPolicyUiSettingsGridItemFormWebComponent';

export { GzPolicyUiSettingsGridItemFormWebComponent };
